module.exports = __webpack_public_path__ + "static/media/bufficorn.e2983bb0.png";